<template>
  <v-app>
    <component
      :is="compNavbar"
      v-show="hasNavbar"
      class="menu-aside"
      :toggle-menu="menuOpen"
      :user="usuario"
      @modalAppAgenda="modalAppAgenda = true"
      @modalSair="modalSairAberto = true"
      @showAvaliacaoModal="handleShowAvaliacaoModal"
    />

    <v-main
      :class="
        $vuetify.breakpoint.width <= 600 || !hasNavbar
          ? 'padding-left-none'
          : 'padding-left-70'
      "
    >
      <v-container
        id="containerPrincipal"
        :class="!hasNavbar ? 'padding-none' : ''"
        fluid
        class="container-custom"
      >
        <keep-alive>
          <router-view
            :usuario="usuario"
            :key="$route.fullPath"
            :click-menu="clickedMenu"
          />
        </keep-alive>
      </v-container>
      <FooterAgir360 v-if="hasFooter" />

      <ModalSucessoErroWarning
        v-if="modalSucessoErroWarning"
        :modal-aberto="modalSucessoErroWarning"
        @close-modal="closeModal"
        :dadosModal="dadosModalSucessoErro"
      />

      <ModalInfoAppAgendaDemo
        v-if="modalAppAgenda && Boolean(usuario.demo)"
        :modal-aberto="modalAppAgenda"
        @close-modal="modalAppAgenda = false"
      />

      <ModalInfoApp
        v-if="modalAppAgenda && !Boolean(usuario.demo)"
        :modal-aberto="modalAppAgenda"
        @close-modal="modalAppAgenda = false"
      />
    </v-main>

    <ModalSair
      :modal-aberto="modalSairAberto"
      @close-modal="modalSairAberto = false"
      @sair="sair()"
      @continuar="modalSairAberto = false"
    />

    <ModalEscolhaAvaliacaoPlataforma
      :modal-aberto="showAvaliacaoModal"
      :grupo-educar-info="grupoEducarInfo"
      @close="closeAvaliacaoModal"
      @select-evoluir="handleSelectEvoluir"
      @show-toast="handleShowToast"
    />

    <ToastRedirecionamento ref="toast" />

    <FloatingMenu v-if="hasFloatingMenu" :usuario="usuario" />

    <!-- loading agora resgatado do store -->
    <loading :dialog-principal="dialog" />
  </v-app>
</template>

<script>
import NavbarProfessor from "../navbar/NavbarProfessor.vue";
import FooterAgir360 from "../footer/FooterAgir360.vue";
import NavbarAluno from "../navbar/NavbarAluno.vue";
import NavbarConteudo from "../navbar/NavbarConteudo.vue";
import NavbarAcesso from "../navbar/NavbarAcesso.vue";
import NavbarGestor from "../navbar/NavbarGestor.vue";
import ModalInfoApp from "@/components/ModalInfoApp";
import ModalInfoAppAgendaDemo from "@/components/ModalInfoAppAgendaDemo";
import ModalEscolhaAvaliacaoPlataforma from "@/components/modais/ModalEscolhaAvaliacaoPlataforma.vue";
import ToastRedirecionamento from "@/components/ToastRedirecionamento.vue";
import educarMaxiaService from "@/utils/services/educarMaxiaService";
import { escolaTemAssistenteIa } from "@/utils/assistenteIa";

import alerts from "@/alerts";
// import Pusher from "pusher-js";
import echoListen from "@/mixins/echo-listen";
import api from "@/api";
import Loading from "../../components/Loading.vue";
import ModalSair from "@/components/ModalSair.vue";
import ModalSucessoErroWarning from "@/components/ModalSucessoErroWarning.vue";
import { mapState, mapActions } from "vuex";
import FloatingMenu from "./assistente-ia/FloatingMenu.vue";
import { colorMappings } from "@/utils/color-maps";
// import Footer from "../footer/Footer.vue";

export default {
  name: "app",
  mixins: [alerts, echoListen],
  components: {
    FooterAgir360,
    ModalSair,
    NavbarProfessor,
    NavbarAluno,
    NavbarConteudo,
    NavbarAcesso,
    ModalInfoApp,
    NavbarGestor,
    Loading,
    ModalInfoAppAgendaDemo,
    ModalSucessoErroWarning,
    ModalEscolhaAvaliacaoPlataforma,
    ToastRedirecionamento,
    FloatingMenu,
  },

  data() {
    return {
      compNavbar: null,
      modalAppAgenda: false,
      modalSairAberto: false,
      notifications: false,
      sound: true,
      widgets: false,
      menuOpen: false,

      privilegio: null,
      showAvaliacaoModal: false,
      currentMenuItem: null,
      grupoEducarInfo: {
        is_grupo_educar: false,
        demo: 0,
        id_escola: null,
      },
    };
  },
  computed: {
    usuario() {
      return this.$store.getters["usuarioStore/user"];
    },
    //Loading agora no app, utilizando o store
    dialog() {
      return this.$store.getters["loadingStore/loading"];
    },
    hasFloatingMenu() {
      if (!this.usuario?.slug_privilegio) return false;
      if (this.$route.path.startsWith("/validation-code")) return false;

      if (!escolaTemAssistenteIa(this.usuario)) return false;

      const isProfessor = this.usuario.slug_privilegio.includes("professor");
      const isAluno = this.usuario.slug_privilegio.includes("aluno");
      const isAssistenteIaRoute = this.$route.path.includes("/assistente-ia");
      if (isProfessor) return true;
      if (isAluno) return !isAssistenteIaRoute;
      return false;
    },

    // Rodapé Agir 360 nas áreas logadas do professor (inclui professor-gestor) e do aluno.
    hasFooter() {
      const slug = this.usuario?.slug_privilegio || "";
      return !this.rotaPublica && (slug.includes("professor") || slug.includes("aluno"));
    },

    // Telas sem menu lateral nem rodapé (login, cadastro, PDF etc.).
    rotaPublica() {
      let exceptions = [
        "/literarios",
        "/",
        "/login",
        "/login2",
        "/cadastro-professor",
        "/cadastro-aluno",
        "/recuperar-senha",
        "/pdf-viewer",
        "/demo",
        "/validation-code",
      ];
      let route = this.$route.path;

      if (route.startsWith("/validation-code") || route.includes("/assistente-ia")) {
        return true;
      }

      return exceptions.some((exception) => route == exception);
    },

    hasNavbar() {
      if (this.rotaPublica) return false;

      // O aluno navega pelo cabeçalho (logo + menu do avatar), sem menu lateral.
      return !this.usuario?.slug_privilegio?.includes("aluno");
    },
    ...mapState("alertStore", [
      "modalSucessoErroWarning",
      "dadosModalSucessoErro",
    ]),
  },
  watch: {
    usuario: {
      handler(value) {
        this.echoListen(value);
        this.privilegio = value.id_privilegio;
        this.changeMenuByPrivilege(this.privilegio);
        this.setColorSystem();
        if (value.id) {
          this.loadGrupoEducarInfo();
        }
      },
      deep: true,
    },
  },
  methods: {
    clickedMenu() {
      this.menuOpen = !this.menuOpen;
    },

    handleShowAvaliacaoModal(item) {
      this.currentMenuItem = item;
      this.showAvaliacaoModal = true;
    },

    handleSelectEvoluir() {
      if (this.currentMenuItem && this.currentMenuItem.rota) {
        this.$router.push(this.currentMenuItem.rota);
      }
    },

    handleShowToast(toastData) {
      this.$refs.toast.showToastMessage(toastData);
    },

    async loadGrupoEducarInfo() {
      try {
        this.grupoEducarInfo = await educarMaxiaService.checkGrupoEducar(
          this.usuario
        );
      } catch (error) {
        console.error(
          "Erro ao carregar informações do grupo Educar:",
          error.message
        );
      }
    },

    closeAvaliacaoModal() {
      this.showAvaliacaoModal = false;
      this.currentMenuItem = null;
    },
    setColorSystem() {
      let mainColor = null;
      let gradient = null;
      let headerGradient = null;
      let secondaryGradient;
      let secondaryColor = null;
      if (this?.usuario?.id && this?.$refs?.body) {
        if (this.usuario.id_privilegio == 3) {
          mainColor = "#3B368D";
          secondaryColor = "#C72E61";
          gradient = "90deg, #3B368D 0%, #E22D59 100%";
          headerGradient = "90deg, #fff 200px, #E22D59 100%";
          secondaryGradient = "90.21deg, #C72E61 -18%, #423589 99.82%";

          this.$refs.body.style.setProperty(
            "--secondary-gradient",
            secondaryGradient
          );
          this.$refs.body.style.setProperty(
            "--secondary-color",
            secondaryColor
          );
        } else {
          mainColor = this.usuario.cor;
          gradient = this.usuario.gradient;
          headerGradient = this.usuario.gradient_header;
        }
      } else {
        mainColor = "#E63B50";
        gradient = "80.58deg, #E53952 8.78%, #EE4949 48.21%, #E17C1E 92.88%";
        headerGradient =
          "80.58deg, #E53952 8.78%, #EE4949 48.21%, #E17C1E 92.88%";
      }
      
      this.$refs.body.style.setProperty("--header-gradient", '90deg, #1348BA 61.27%, #17618D 116.4%');
      this.$refs.body.style.setProperty("--main-color", '#1348BA');
      this.$refs.body.style.setProperty("--secondary-color", colorMappings[mainColor]?.secondaryColor);
      this.$refs.body.style.setProperty("--tertiary-color", colorMappings[mainColor]?.tertiaryColor );
      this.$refs.html.style.setProperty("--plyr-color-main", mainColor);
      this.$refs.body.style.setProperty("--main-gradient", '90deg, #1348BA 61.27%, #17618D 116.4%');
    },

    changeMenuByPrivilege(privilege) {
      switch (privilege) {
        case 3:
          this.compNavbar = NavbarAluno;
          break;
        case 2:
          this.compNavbar = NavbarProfessor;
          break;
        case 5:
          this.compNavbar = NavbarConteudo;
          break;
        case 7:
          this.compNavbar = NavbarAcesso;
          break;
        case 6:
          this.compNavbar = NavbarGestor;
          break;
      }
    },

    sair() {
      this.modalSairAberto = false;
      api.post("/sair");
      this.$router.replace("/");
    },
    ...mapActions("alertStore", ["closeModal"]),
  },
  provide() {
    return {
      clickMenuApp: this.clickedMenu,
      usuario: this.usuario,
    };
  },

  mounted() {
    this.$refs.body = document.querySelector("body");
    this.$refs.html = document.documentElement;
    window.onbeforeunload = () => {
      const token = window.localStorage.getItem("token");
      if (!token) {
        return;
      }

      // fetch sem o axios: o interceptor de 401 redireciona para o login
      // e intercepta o logout do professor rumo ao PDCA.
      fetch(
        `${process.env.VUE_APP_API_URL}/historico_acesso_gestor/atualizar-saida`,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
          keepalive: true,
        }
      ).catch(() => {});
    };

    this.setColorSystem();
    // this.getColorSystem();
    // this.menus = this.verificarMenus();

    // Remove da Url o mt para validação do usuário de degustação
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("mt")) {
      urlParams.delete("mt");
      let newQuery = urlParams.toString();
      // Verifique se há outros parâmetros na query
      if (newQuery.length > 0) {
        newQuery = "?" + newQuery;
      }

      this.$router.push({ path: location.pathname + newQuery });
    }
  },
};
</script>
<style lang="scss">
body {
  --main-color: "";
  --main-gradient: "";
}

.cor-sistema {
  background: var(--main-color);
}

.menu-aside {
  position: fixed;
  left: 0px;
  top: 0px;
  bottom: 0px;

  @media (max-width: 600px) {
    padding-top: 20px;
  }
}

.absolute {
  position: absolute;
}

.w-full {
  width: 100%;
}

.container-custom {
  height: 100%;
  background: #f7f9fd;
  display: flex;
  flex-direction: column;
  flex: 2;
}

.border-botom--table {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.border-left--red {
  border-left: 2px solid #e7a0a7;
}

.bg-table--red {
  background-color: #ffdfe2;
}

.border-left--blue {
  border-left: 2px solid #648bc5;
}

.bg-table--blue {
  background-color: #abccee;
}

.border-left--orange {
  border-left: 2px solid #e7c28b;
}

.bg-table--orange {
  background-color: #ffedd2;
}

.border-left--green {
  border-left: 2px solid #99da9b;
}

.bg-table--green {
  background-color: #def3df;
}

.divisor {
  height: 2px;
  width: calc(100% - 16px);
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ddd;
  outline: none;
  border: none;
}

.lista--ativa {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 12px;
}

.transparent::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  background-attachment: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.padding-left-70 {
  padding-left: 70px !important;
}

.padding-left-none {
  padding-left: 0px !important;
}

.padding-none {
  padding: 0 !important;
}
</style>
